import styled from 'styled-components'

export const NormativeBasePageWrapper = styled.div`
	padding: 200px 10px 50px 10px;
	max-width: 1400px;
	margin: 0 auto;
	width: 95%;
	display: flex;
	flex-direction: column;
	gap: 20px;
`

export const DocumentsContainer = styled.div`
	margin-top: 50px;
	margin-bottom: 20px;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	width: 100%;
	max-width: 1300px;
	gap: 40px;

	@media (max-width: 768px) {
		flex-direction: column;
		gap: 20px;
		margin-top: 30px;
	}
`

export const DocumentTitle = styled.h3`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 36px;
	line-height: 120%;
	color: #01924f;
	width: 60%;
	margin: 0;

	@media (max-width: 1200px) {
		font-size: 28px;
	}

	@media (max-width: 768px) {
		font-size: 22px;
		width: 100%;
	}

	@media (max-width: 430px) {
		font-size: 18px;
	}
`

export const DocumentsList = styled.ul`
	list-style: none;
	padding: 10px 0 10px 50px;
	margin: 0;
	width: 47%;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 4px;
		bottom: 4px;
		width: 3px;
		background-color: #01924f;
		border-radius: 2px;
	}

	@media (max-width: 768px) {
		width: 100%;
		padding-left: 24px;
	}

	@media (max-width: 530px) {
		padding-left: 15px;
	}
`

export const DocumentItem = styled.li`
  margin-bottom: 20px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
     margin-bottom: 10px;
    }

a {
  font-family: "e-Ukraine", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  color: #484848;
  text-decoration: none;
  display: inline;   
  align-items: baseline;  
  gap: 4px;
  width: fit-content;     
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #01924f;

    span:first-child {
      text-decoration: underline;
      text-decoration-skip-ink: none;
    }

    span:last-child {
      color: #01924f;
      text-decoration: none;
    }
  }

  span:last-child {
    color: #484848;
    font-size: 16px;      
    flex-shrink: 0;
      margin-left: 8px;
      display: inline;  
    text-decoration: none;
    transition: color 0.2s ease-in-out;
  }

  @media (max-width: 1200px) {
    font-size: 15px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 430px) {
    font-size: 13px;

    span:last-child {
      font-size: 13px;
    }
  }
}
  }
`

export const DocumentText = styled.span`
	text-decoration: none;
	transition: color 0.2s ease-in-out;
`
